import React, {useEffect, useState} from 'react';
import EnvironmentControl from './EnvironmentControl';
import EnvironmentStatus from './EnvironmentStatus';
import '../styles/Dashboard.css';

const Dashboard = ({ authTokens, showAlert }) => {
  const [environmentStatus, setEnvironmentStatus] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEnvironmentStatus = async () => {
    setLoading(true);
    try {
      console.log('Fetching environment status with token:', authTokens.tokenType, authTokens.accessToken);

      const response = await fetch('https://uquqfl7xad.execute-api.ap-southeast-2.amazonaws.com/prod/env-status', {
        headers: {
          'Authorization': `${authTokens.accessToken}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Environment status:', data.data);

      setEnvironmentStatus(data.data);
    //   setEnvironmentStatus([
    //   {
    //     environment: "Premium Development",
    //     status: "Stopped",
    //     "started_by": "",
    //     stop_time: "—"
    //   },
    //   {
    //     environment: "Premium QA",
    //     status: "Stopped",
    //     "started_by": "",
    //     stop_time: "—"
    //   },
    //   {
    //     environment: "Tentacle Development",
    //     status: "Stopped",
    //     "started_by": "",
    //     stop_time: "—"
    //   },
    //   {
    //     environment: "Tentacle QA",
    //     status: "Stopped",
    //     "started_by": "",
    //     stop_time: "—"
    //   },
    //   {
    //     environment: "Adoption Development",
    //     status: "Stopped",
    //     "started_by": "",
    //     stop_time: "—"
    //   },
    //   {
    //     environment: "Adoption QA",
    //     status: "Stopped",
    //     "started_by": "",
    //     stop_time: "—"
    //   }
    // ]);

    } catch (error) {
      console.error('Error fetching environment status:', error);
      showAlert('error', 'Failed to fetch environment status');
    } finally {
      setLoading(false);
    }
  };

  // Initial fetch on component mount
  useEffect(() => {
    if (authTokens.accessToken) {
      fetchEnvironmentStatus();
    }
  }, [authTokens]);

  // Set up refresh interval (every 30 seconds)
  useEffect(() => {
    if (!authTokens.accessToken) return;

    const intervalId = setInterval(() => {
      fetchEnvironmentStatus();
    }, 30000); // 30 seconds

    return () => clearInterval(intervalId); // Clean up on component unmount
  }, [authTokens]);

  return (
    <div className="dashboard">
      <h1 className="dashboard-title">ENVIRONMENT AUTOMATION</h1>

      <EnvironmentControl
        authTokens={authTokens}
        showAlert={showAlert}
        onActionComplete={fetchEnvironmentStatus}
      />

      <EnvironmentStatus
        data={environmentStatus}
        loading={loading}
        onRefresh={fetchEnvironmentStatus}
      />
    </div>
  );
};

export default Dashboard;